module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{},"de":{"Imprint":"Impressum","Privacy":"Datenschutz"}}')
  delete Component.options._Ctor
}
